<div class="header">
    <div class="header-root">
        <div class="header-container container-fluid-header">
            <div class="cpsLogoDiv">
                <!-- <span class="cpsLogo site-logo-header">
                </span> -->
                <span class="cpsLogoText">
                    CPhA Hub
                </span>
            </div>

            <div class="right-menu">
                <button class="goToCpsButton" *ngIf="showHeaderButtons" (click)="goToCps()">
                    {{ 'Home.gotocps' | translate }}
                </button>

                <span class="logoutText" *ngIf="showHeaderButtons" (click)="logout()">{{ 'Home.logout' | translate }}</span>
                <span class="divider">|</span>
        
                <div class="langChangeText" (click)="changeLang()">
                  <span>{{ languageChangeText }}</span>
                </div>
            </div>                
        </div>
    </div>
</div>